import { api } from "shared/config/api/api";
import type {
  AuthRequest,
  AuthResponse,
  LoginResult,
  OAuthGoogleRequest,
  OAuthRedditRequest,
} from "../model/types";

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    userRegister: builder.mutation<AuthResponse, AuthRequest>({
      query: (authRequest) => ({
        url: "/auth/register/password",
        method: "POST",
        body: authRequest,
      }),
    }),
    userLogin: builder.mutation<LoginResult, AuthRequest>({
      query: (authRequest) => ({
        url: "/auth/login/password",
        method: "POST",
        body: authRequest,
      }),
    }),
    oauthGoogleLogin: builder.mutation<LoginResult, OAuthGoogleRequest>({
      query: (oauthRequest) => ({
        url: "/auth/google/token",
        method: "POST",
        body: oauthRequest,
      }),
    }),
    oauthRedditLogin: builder.mutation<LoginResult, OAuthRedditRequest>({
      query: (oauthRequest) => ({
        url: "/auth/reddit/token",
        method: "POST",
        body: oauthRequest,
      }),
    }),
    updateAccessToken: builder.mutation<{ access_token: string }, void>({
      query: () => ({
        url: "/auth/refresh",
        method: "POST",
      }),
    }),
    userLogout: builder.mutation<{ message: string }, void>({
      query: () => ({
        url: "/auth/logout",
        method: "POST",
      }),
    }),
  }),
});

export const {
  useUserRegisterMutation,
  useUserLoginMutation,
  useOauthGoogleLoginMutation,
  useOauthRedditLoginMutation,
  useUpdateAccessTokenMutation,
  useUserLogoutMutation,
} = authApi;
